export default "__VITE_ASSET__Cvjw_jpv__"